export default __webpack_public_path__ + "static/media/reports.aaf490e3.svg";